import useMatchesMedia from './useMatchesMedia'

export default function usePrefersReducedMotion() {
  return useMatchesMedia('(prefers-reduced-motion)')
}
